<div class="content-with-stepper-and-title">
    <div class="row">
        <div class="col-4 col-pr-12 col-sm-8 col-md-12 col-xl-12 col-lg-12">
            <h1 class="title">{{screenCopies.title}}</h1>
            <p class="description mt-3">{{screenCopies.subtitle}}</p>            
        </div>
    </div>
    <div class="note mt-auto mb-sm-auto mt-sm-4">
        <span class="info">{{screenCopies.footer}}</span>
    </div>
    <app-controls id="btns" [hasPrevious]="true" nextLabel="Aceptar" (only_previous)="sendBackButtonEvent()" (next)="next()"></app-controls>
</div>